<form [formGroup]="formGroup">

    <app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>
	<app-form-field [type]="fields.client_id.type" [options]="fields.client_id.options"></app-form-field>
	<app-form-field [type]="fields.raspberry_number.type" [options]="fields.raspberry_number.options"></app-form-field>
	<app-form-field [type]="fields.raspberry_number_2.type" [options]="fields.raspberry_number_2.options"></app-form-field>
	<app-form-field [type]="fields.phone_number.type" [options]="fields.phone_number.options"></app-form-field>
	<app-form-field [type]="fields.router.type" [options]="fields.router.options"></app-form-field>
	<app-form-field [type]="fields.description.type" [options]="fields.description.options"></app-form-field>
	<app-form-field [type]="fields.active.type" [options]="fields.active.options"></app-form-field>
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
